module.exports = __webpack_public_path__ + "static/media/19-jul23sep23.86c82949.pdf";